/**
 * Hook for fetching valid economic activity codes from Alanube's catalog.
 *
 * Used to validate client activity codes against what Alanube accepts
 * for electronic invoicing. Cached for 24 hours (staleTime).
 */

import { useQuery } from '@tanstack/react-query'
import api from '@/lib/api'

interface ValidActivityCodesResponse {
  codes: string[]
}

export function useValidActivityCodes() {
  return useQuery<ValidActivityCodesResponse>({
    queryKey: ['valid-activity-codes'],
    queryFn: async () => {
      const response = await api.get('/invoicing/valid-activity-codes')
      return response.data
    },
    staleTime: 24 * 60 * 60 * 1000, // 24 hours
    retry: 1,
  })
}

export interface ActivityCatalogItem {
  code: string
  name: string
}

interface ActivityCatalogResponse {
  activities: ActivityCatalogItem[]
}

export function useActivityCatalog() {
  return useQuery<ActivityCatalogResponse>({
    queryKey: ['activity-catalog'],
    queryFn: async () => {
      const response = await api.get('/invoicing/activity-catalog')
      return response.data
    },
    staleTime: 24 * 60 * 60 * 1000, // 24 hours
    retry: 1,
  })
}
